import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import Policy_Navbar from './PolicyNavbar';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';
import { MdOutlineEdit } from "react-icons/md";
import { IoSaveSharp } from "react-icons/io5";

const Policy = () => {
    const [loader, setLoader] = useState(false);
    const [policy, setPolicy] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [editedPolicy, setEditedPolicy] = useState({
        policy_title: '',
        policy_description: ''
    });

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getPolicy();
            if (resp?.status) {
                setPolicy(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoader(false);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedPolicy(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSave = async () => {
        setLoader(true);
        try {
            const resp = await Calling.updatePolicy(editedPolicy);
            if (resp?.status) {
                toast.success('Policy updated successfully');
                setPolicy(editedPolicy);
                setIsEditing(false);
            } else {
                toast.error(resp?.message);
            }
        } catch (err) {
            console.log(err);
            toast.error('Failed to update policy');
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setEditedPolicy({
            policy_title: policy?.policy_title || '',
            policy_description: policy?.policy_description || ''
        });
    }, [policy]);

    return (
        <>
            {loader ? <Loader loader={loader} /> : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2">
                        <h1 className="text-xl sm:text-2xl font-bold">Privacy Policy</h1>
                    </div>
                    <div className='bg-main-white rounded-xl pt-3 mb-5 mt-3 overflow-hidden'>
                        <Policy_Navbar
                            selectState={'policy'}
                            onClick={() => isEditing ? handleSave() : setIsEditing(true)}
                            label={isEditing ? 'Save' : 'Edit'}
                            className={`px-3 sm:px-4 py-1 rounded-lg border text-sm sm:text-base ${isEditing ? 'bg-main-blue text-main-white' : 'bg-main-white text-main-delete border-main-delete'} transition hover:scale-105`}
                            icon={isEditing ? <IoSaveSharp size={16} className="sm:text-lg" /> : <MdOutlineEdit size={16} className="sm:text-lg" />}
                            btnSave={isEditing}
                        />
                        <hr className='mt-3 bg-main-border border-[1px]' />
                        <div className="w-full p-3 sm:p-5">
                            <div className="flex justify-between items-center">
                                {isEditing ? (
                                    <div className='w-full'>
                                        <div className='text-main-font my-2 font-bold text-sm sm:text-base'>Add Privacy Policy Title</div>
                                        <input
                                            type="text"
                                            name="policy_title"
                                            value={editedPolicy.policy_title}
                                            onChange={handleInputChange}
                                            className="w-full border p-2 rounded text-sm sm:text-base"
                                            placeholder='Enter Privacy Policy Title'
                                        />
                                    </div>
                                ) : (
                                    <h1 className="text-lg sm:text-2xl font-bold break-words">{policy?.policy_title}</h1>
                                )}
                            </div>

                            <div className="mt-6 sm:mt-10">
                                {isEditing ? (
                                    <div className='w-full'>
                                        <div className='text-main-font my-2 font-bold text-sm sm:text-base'>Add Privacy Policy Description</div>
                                        <textarea
                                            name="policy_description"
                                            value={editedPolicy.policy_description}
                                            onChange={handleInputChange}
                                            className="w-full h-[200px] sm:h-[300px] border p-2 rounded text-sm sm:text-base"
                                            placeholder='Enter Privacy Policy Description'
                                        />
                                    </div>
                                ) : (
                                    <pre className="text-base sm:text-lg font-medium break-words whitespace-pre-wrap">{policy?.policy_description}</pre>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Policy;